import React from 'react';
import Header from '../../navigation/Header';
import Footer from '../../footer/Footer';
import { MaintenanceAppointmentsBox, extractHairExtensionsInfo } from '../HairExtensions';
import { ReadLess } from '../../../common/commonUtils';
import "../HairExtensions.css"

export default function MaintenanceAppointments() {
    const info = extractHairExtensionsInfo()
    return (
        <div className='brands-container'>
            <Header/>
            <div className='mobile-view-hair-extensions'>
                <MaintenanceAppointmentsBox
                    isDesktop={true}
                    textBody={info.section2}
                />
                <br/>
                <ReadLess
                    page="hairExtensions"
                />
            </div>
            <Footer/>
        </div>
    )
}